/* unplugin-vue-components disabled */import script from "./selectUser.vue?vue&type=script&setup=true&name=SelectUser&lang=js"
export * from "./selectUser.vue?vue&type=script&setup=true&name=SelectUser&lang=js"

import "./selectUser.vue?vue&type=style&index=0&id=d8d56efc&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d8d56efc"]])

export default __exports__